/* eslint-disable no-console */
import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import { compareSort } from '@/vue-dlb/common/common';

const baseURI = config.monitoringApiUrl;
const setupURI = config.setupApiUrl;
const prnrURI = config.companyApiUrl;
const reprocessURI = config.ReprocessApiUrl;

const monitoringStoreModule = {

  state: {
    monitoringList: [],
    monitoringListSource: [],
    monitoringListForFilter: [],
    inputFileContents: null,
    outputFileContents: null,
    outputBizFileContents: null,
    communicationInfo: {},
    partnerUseList: [],
    totalCnt: null,
    statusInfo: {},
    stateViewPopupListInfo: [],
    processSetupList: [],
  },
  mutations: {
    'SET_STORE_MONITOR_LIST'(state, monitoringList) {
      state.monitoringList = monitoringList;
      state.monitoringListSource = monitoringList;
      state.monitoringListForFilter = monitoringList;
    },
    'SET_STORE_TOTAL_CNT'(state, trsDataCnt) {
      state.totalCnt = trsDataCnt;
    },
    'SET_STORE_INPUT_FILE_CONTENTS'(state, fileContents) {
      state.inputFileContents = fileContents;
    },
    'SET_STORE_OUTPUT_FILE_CONTENTS'(state, fileContents) {
      state.outputFileContents = fileContents;
    },
    'SET_STORE_OUTPUT_BIZFILE_CONTENTS'(state, fileContents) {
      state.outputBizFileContents = fileContents;
    },
    'SET_STORE_COMM_LIST'(state, communicationInfo) {
      state.communicationInfo = communicationInfo;
    },
    'SET_STORE_PROCESS_SETUP_LIST'(state, processSetupList) {
      processSetupList === null ? state.processSetupList = [] : state.processSetupList = processSetupList;
    },
    'SET_STORE_STATUS_INFO'(state, statusInfo) {
      state.statusInfo = statusInfo;
    },
    'SET_STORE_STATE_LIST_INFO'(state, stateViewPopupListInfo) {
      state.stateViewPopupListInfo = stateViewPopupListInfo;
    },
    'SET_STORE_TRANSACTION_LOG_FILTER'(state, filter) {
      let datarows = state.monitoringListSource;
      state.filter = filter;
      let filterBy = state.filter;
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }

        listResult = datarows.filter(item => {
          if (filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }

              for (const prop in item.trans) {
                if (typeof item.trans[prop] == 'string') {
                  let propValue = item.trans[prop].toLowerCase();
                  let queryValue = str.toLowerCase();
                  if (propValue.includes(queryValue)) {
                    return true;
                  }
                } else if (typeof item.trans[prop] == 'number') {
                  let propValue = item.trans[prop].toString().toLowerCase();
                  let queryValue = str.toLowerCase();
                  if (propValue.includes(queryValue)) {
                    return true;
                  }
                }
              }
            }
          } else {
            if (filter === "senderId" || filter === "recipientId" || filter === "messageReferenceId") {
              if (typeof item.record.messageInfo[filter] == 'string') {
                let propValue = item.record.messageInfo[filter].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item.record.messageInfo[filter] == 'number') {
                let propValue = item.record.messageInfo[filter].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            } else {
              if (typeof item[filter] == 'string') {
                let propValue = item[filter].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[filter] == 'number') {
                let propValue = item[filter].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          }

          return false;
        });
      }
      state.monitoringList = listResult;
    },
    // 2021.7.27 203728 SPKA-162 Function sort Transacton list
    sortmonitoringList(state, colSort) {
      let datarows = state.monitoringList;

      let { col, sort } = colSort;
      if (sort == 'reset') {
        state.monitoringList = state.monitoringListSource;
        return;
      }

      datarows.sort((a, b) => {
        return compareSort(a.record.messageInfo[col], b.record.messageInfo[col], sort);
      });

      state.monitoringList = datarows;
    },
  },
  actions: {
    getMonitoringList: async ({ commit, state }, params) => {
      let statuses = '';
      if (params.status !== '') {
        statuses = `/states/${params.status.toLowerCase()}`;
      }
      /**
       * 2021.09.14 203737 SPKA-210 Modify search condition of Transaction Log
       * Add "Test, Live" radio button
          Test : https://alb.smartlink-platform.com:3200/monitoring/test/users/cyberlogitec.com
          Live : https://alb.smartlink-platform.com:3200/monitoring/prod/users/cyberlogitec.com
       */
      // 2021.11.8 203728 SPKA-245 move to config
      // 2021.12.09 213960 SPKA-324 Remove "Test" and "Live" radio button
      // let strEnvMode = envServerMode[params.radioEnvMode];
      // state.strEnvMode = strEnvMode;
      /**
       * 2021.3.30 203728 SPKA-56
       * URL format Ownr : {baseURI}/monitoring/users/ownrId?
       * URL format Company : {baseURI}/monitoring/users/ownrId/company?
       */
      let url = `${baseURI}/monitoring/users/`;
      // Ownr
      if (params.ownrId === params.groupId) {
        // If not select combobox or choose same as ownr
        if (params.company == '' || params.ownrId === params.company) url += `${params.ownrId}${statuses}?`;
        // If choose combobox
        else url += `${params.ownrId}/${params.company}${statuses}?`;
      }
      else {
        // Company
        url += `${params.ownrId}/${params.groupId}${statuses}?`;
      }

      let filterparms = "";

      if (params.dateCond) {
        filterparms = `dateTime BETWEEN '${params.fromDateData}' AND '${params.toDateData}'`;
      }
      if (params.senderId !== '') {
        if (params.dateCond) filterparms += ` AND `;
        filterparms += `senderId like '${params.senderId}'`;
      }
      if (params.recipientId !== '') {
        if (params.dateCond || params.senderId !== '') filterparms += ` AND `;
        filterparms += `recipientId like '${params.recipientId}'`;
      }

      // 2021.9.17 203728 change eq to like for processSetupId-version
      if (params.processSetupId !== '') {
        if (params.dateCond || params.senderId !== ''
          || params.recipientId !== '' || params.message !== '') filterparms += ` AND `;
        filterparms += `(processSetupId like '${params.processSetupId}')`;
      }
      if (params.messageReferenceId !== '') {
        if (params.dateCond || params.senderId !== ''
          || params.recipientId !== '' || params.message !== ''
          || params.processSetupId !== '') filterparms += ` AND `;
        filterparms += `(messageReferenceId eq '${params.messageReferenceId}')`;
      }
      // 05/18/2021 203737 SPKA-109 issue 61 Add direction in search condition of called API for Transaction Log
      // 2021.5.21 203728 [BIZ] [No ticket jira] Change : AND direction='I' --> AND direction eq 'I'
      if (params.direction) {
        filterparms += ` AND direction eq '${params.direction}'`;
      }

      if (params.dateCond || params.senderId !== ''
        || params.recipientId !== '' || params.message !== ''
        || params.processSetupId !== '' || params.messageReferenceId !== '' || params.srchKeyVal === '') filterparms += `&`;
      filterparms += `orderBy=dateTime desc`;
      if (params.page != '') {
        filterparms += `&page=${params.page}`;
      }
      if (params.perPage != '') {
        filterparms += `&perPage=${params.perPage}`;
      }
      // 2021.10.11 203728 SPKA-234 add processId
      if (params.srchKey1 != 'processId') {
        filterparms += `&key1=${params.srchKey1}`;
      }
      if (params.srchKeyVal1 !== '') {
        if (params.srchKey1 != 'processId') {
          filterparms += `&value1=${params.srchKeyVal1}`;
        } else {
          filterparms += `&processId=${params.srchKeyVal1}`;
        }
      } else if (params.srchKeyVal2 !== '') {
        filterparms += `&value1=${params.srchKeyVal2}`;
      }

      if (params.srchKey2 !== '') {
        filterparms += `&key2=${params.srchKey2}`;
      }

      if (params.srchKeyVal2 !== '' && params.srchKeyVal1 != '') {
        if (params.srchKey2 != 'processId') {
          filterparms += `&value2=${params.srchKeyVal2}`;
        } else {
          filterparms += `&processId=${params.srchKeyVal2}`;
        }
      }
      if (params.message !== '') {
        filterparms += `&messageCode=${params.message}`;
      }

      let filter = "";
      if (!(!params.dateCond && params.srchKeyVal !== '') || params.senderId !== ''
        || params.recipientId !== '' || params.message !== ''
        || params.processSetupId !== '' || params.messageReferenceId !== '') filter = `filter=${filterparms}`;
      else filter = filterparms;
      url = url + filter;

      console.log("url : " + url);
      await axios.get(url).then(async (response) => {

        let trsData2 = [];
        let trsDataCnt = 0;

        if (response.data == "No Results Found") {
          response.data = [];
        } else {
          const trsData = response.data.data;
          trsDataCnt = response.data.totalCnt;

          let procData = [];
          let prnrData = [];

          await axios.post(`${setupURI}/process/list/fortransaction`, params).then(async (res) => {
            procData = res.data;
          }).catch((e) => {
            procData = [];
          });

          await axios.post(`${prnrURI}/partner/list`, params).then(async (res) => {
            prnrData = res.data;
          }).catch((e) => {
            prnrData = [];
          });

          for (let i = 0; trsData.length > i; i += 1) {
            for (let j = 0; procData.length > j; j += 1) {
              // 2021.9.17 203728 processSetupId-version
              if (trsData[i].processSetupId.includes(procData[j].processSetupId)) {
                // 2022.10.18 203728 SPKA-548
                if (!trsData[i].record.messageInfo.senderId) {
                  trsData[i].record.messageInfo.senderId = procData[j].sender;
                }
                if (!trsData[i].record.messageInfo.recipientId) {
                  trsData[i].record.messageInfo.recipientId = procData[j].receiver;
                }

                trsData[i].processSetupName = procData[j].processSetupName;
                trsData[i].partnerId = procData[j].partnerId;
                trsData[i].direction = procData[j].direction;

                if (trsData[i].partnerId !== '') {
                  for (let k = 0; prnrData.length > k; k += 1) {
                    if (trsData[i].partnerId === prnrData[k].prnrId) {
                      trsData[i].partnerName = prnrData[k].prnrNm
                    }
                  }
                }
                break;
              }
            }
          }

          let m = 0;
          if (params.messageDirection !== '') {
            for (let k = 0; trsData.length > k; k += 1) {
              if (params.messageDirection === trsData[k].direction) {
                trsData2[m] = trsData[k];
                m++;
              }
            }
          } else {
            trsData2 = trsData;
          }
        }

        for (let i = 0; i < trsData2.length; i++) {
          const row = trsData2[i];
          row.data = {
            "header": {
              "groupId": row.groupId,
              "userId": row.userId,
              "processSetupId": row.processSetupId,
              "processId": row.processId,
              "targetFileName": "",
              "eventCode": "DATA_RE_PROCESS"
            },
            "payload": {
              "messageSequence": row.record.messageSequence,
              "resourceId": "",
              "reprocessTarget": row.record.reprocessTarget,
              "taskId": "",
              "fileLink": row.record.transInput.fileLink,
              "called": "communication",
              "userData": {
                "fileName": row.record.sourceFileName,
                "processId": row.processId
              },
              "mappingId": row.record.messageInfo.mappingId,
              "senderId": row.record.messageInfo.senderId,
              "recipientId": row.record.messageInfo.recipientId,
              "messageName": row.record.messageInfo.messageName,
              "fileContent": ""
            }
          };
        }

        commit('SET_STORE_MONITOR_LIST', trsData2);
        commit('SET_STORE_TOTAL_CNT', trsDataCnt);
      }).catch((ex) => {
        console.log(ex);
        throw ex;
      });
    },

    getStatusInfo: async ({ commit }, params) => {
      let url = `${baseURI}/monitoring/users/${params.groupId}/${params.userId}/status/${params.processId}/${params.record.messageSequence}`;
      console.log("status view url : " + url);
      await axios.get(url).then(async (response) => {
        commit('SET_STORE_STATUS_INFO', response.data.data[0]);
      }).catch((ex) => {
        console.log(ex);
      });
    },

    // 2021.11.4 203728 SPKA-245 Get data for transaction excel
    // 2021.11.9 203728 SPKA-245 Modify condtion search
    getMonitoringExcelData: async ({ commit, state }, params) => {

      /**
       * 2021.11.4 203728 SPKA-245
       * Get Excel data
          https://alb.smartlink-platform.com:3200/monitoring/prod/users/cyberlogitec.com?filter=...&orderBy=dateTime desc&download=Y
       */
      // 2021.11.8 203728 SPKA-245 move to config
      // 2021.12.09 213960 SPKA-324 Remove "Test" and "Live" radio button
      // let strEnvMode = envServerMode[params.radioEnvMode];
      // state.strEnvMode = strEnvMode;

      let statuses = '';
      if (params.status !== '') {
        statuses = `/states/${params.status.toLowerCase()}`;
      }

      let url = `${baseURI}/monitoring/users/`;
      if (params.ownrId === params.groupId) {
        if (params.company == '' || params.ownrId === params.company) url += `${params.ownrId}${statuses}?`;
        else url += `${params.ownrId}/${params.company}${statuses}?`;
      }
      else {
        url += `${params.ownrId}/${params.groupId}${statuses}?`;
      }

      let filterparms = "";

      if (params.dateCond) {
        filterparms = `dateTime BETWEEN '${params.fromDateData}' AND '${params.toDateData}'`;
      }
      if (params.senderId !== '') {
        if (params.dateCond) filterparms += ` AND `;
        filterparms += `senderId like '${params.senderId}'`;
      }
      if (params.recipientId !== '') {
        if (params.dateCond || params.senderId !== '') filterparms += ` AND `;
        filterparms += `recipientId like '${params.recipientId}'`;
      }
      if (params.message !== '') {
        if (params.dateCond || params.senderId !== ''
          || params.recipientId !== '') filterparms += ` AND `;
        filterparms += `(messageName eq '${params.message}')`;
      }

      // 2021.9.17 203728 change eq to like for processSetupId-version
      if (params.processSetupId !== '') {
        if (params.dateCond || params.senderId !== ''
          || params.recipientId !== '' || params.message !== '') filterparms += ` AND `;
        filterparms += `(processSetupId like '${params.processSetupId}')`;
      }
      if (params.messageReferenceId !== '') {
        if (params.dateCond || params.senderId !== ''
          || params.recipientId !== '' || params.message !== ''
          || params.processSetupId !== '') filterparms += ` AND `;
        filterparms += `(messageReferenceId eq '${params.messageReferenceId}')`;
      }
      // 05/18/2021 203737 SPKA-109 issue 61 Add direction in search condition of called API for Transaction Log
      // 2021.5.21 203728 [BIZ] [No ticket jira] Change : AND direction='I' --> AND direction eq 'I'
      if (params.direction) {
        filterparms += ` AND direction eq '${params.direction}'`;
      }

      if (params.dateCond || params.senderId !== ''
        || params.recipientId !== '' || params.message !== ''
        || params.processSetupId !== '' || params.messageReferenceId !== '' || params.srchKeyVal === '') filterparms += `&`;
      filterparms += `orderBy=dateTime desc`;

      // 2021.10.11 203728 SPKA-234 add processId
      if (params.srchKey != 'processId') {
        filterparms += `&key=${params.srchKey}`;
      }
      if (params.srchKeyVal !== '') {
        if (params.srchKey != 'processId') {
          filterparms += `&value=${params.srchKeyVal}`;
        } else {
          filterparms += `&processId=${params.srchKeyVal}`;
        }
      }

      let filter = "";
      if (!(!params.dateCond && params.srchKeyVal !== '') || params.senderId !== ''
        || params.recipientId !== '' || params.message !== ''
        || params.processSetupId !== '' || params.messageReferenceId !== '') filter = `filter=${filterparms}`;
      else filter = filterparms;
      url = url + filter + '&download=Y';

      console.log("url : " + url);
      return await axios.get(url).then(async (response) => {
        let data = [];
        let header = response.data[0];
        response.data.forEach((e, k) => {
          data[k] = {};
          header.map((r, i) => {
            data[k][r] = e[i];
          })
        });
        data.shift();
        return data;
      }).catch((ex) => {
        console.log(ex);
        throw ex;
      });
    },

    getCommunicationsInfo: async ({ commit }, params) => {
      try {
        const resrcIdParams = [];
        let i = 0;
        if (params.processSetupId !== undefined) {
          resrcIdParams[`${i}`] = params.processSetupId;
          console.log("processSetupId: " + resrcIdParams[`${i}`]);
          i++;
        }
        if (params.recv.input !== undefined) {
          resrcIdParams[`${i}`] = params.recv.input.resourceId;
          console.log("input.resourceId: " + resrcIdParams[`${i}`]);
          i++;
        }
        if (params.send.output !== undefined) {
          resrcIdParams[`${i}`] = params.send.output.resourceId;
          console.log("output.resourceId: " + resrcIdParams[`${i}`]);
          i++;
        }

        const response = await axios.post(`${setupURI}/comm/list/fortransaction`, resrcIdParams);

        let commData = [];
        commData = response.data;
        const tmpData = {};
        // console.log("commData : " + JSON.stringify(commData));
        for (let i = 0; commData.length > i; i += 1) {
          if (commData[`${i}`][0] !== undefined) {
            if (params.recv.input !== undefined && params.recv.input.resourceId === commData[`${i}`][0].resourceId)
              params.recv.input.commInfo = commData[`${i}`][0];
            if (params.send.output !== undefined && params.send.output.resourceId === commData[`${i}`][0].resourceId)
              params.send.output.commInfo = commData[`${i}`][0];
          }
        }
        // console.log("getCommunicationsInfo : " + JSON.stringify(params));
        commit('SET_STORE_COMM_LIST', params);
      } catch (err) {
        console.log(err);
        throw err;
      }
    },

    getStateViewPopupListInfo: async ({ commit, state }, params) => {
      try {
        //let url = `${baseURI}/monitoring/users/${params.groupId}/${params.userId}/status/${params.processId}/${params.record.messageSequence}`;
        //const response_status = await axios.post(`${url}`);   
        // 2021.11.8 203728 SPKA-245 rename
        // 2021.12.09 213960 SPKA-324 Remove "Test" and "Live" radio button
        // let strEnvMode = state.strEnvMode;
        let procDataList = [];

        // 2021.9.27 203728 get last record from bottom for state data
        let url = `${baseURI}/monitoring/users/${params.groupId}/${params.userId}/status/${params.processId}/${params.record.messageSequence}`;
        await axios.get(url).then(async (response_state) => {
          let data = response_state.data.data;
          for (let k = 0; data.length > k; k += 1) {
            let stateData = data[k].state;
            let response_proc = await axios.post(`${setupURI}/process/list/forstateinfo`, { processSetupId: data[k].processSetupId });
            let route_info = await axios.post(`${setupURI}/process/list/routeinfo`, { processSetupId: data[k].processSetupId });
            let procData = response_proc.data;
            let tempRouteData = route_info.data;
            // let routeData = JSON.parse(tempRouteData[0].message).payload.transfer.routes;
            let currentProcessVersion = JSON.parse(tempRouteData[0].message).header.processSetupId;
            let handledProcessVersion = data[k].processSetupId;
            let versionCheckFlag = 'S';
            if (currentProcessVersion != handledProcessVersion) versionCheckFlag = 'F';
            // console.log(JSON.stringify(routeData))


            // 2021.9.30 203728 don't show if have no data
            if (procData.length === 0) continue;
            let procList = [];
            for (let j = stateData.length - 1; j >= 0; j -= 1) {
              let comFlag = true;
              let index = procData.findIndex(e => (stateData[j].resourceId.includes(e.procCommId) || e.procCommId === stateData[j].mappingId));
              if (index > -1) {
                let record = { ...procData[index] };
                record.versionCheckFlag = versionCheckFlag;
                if (versionCheckFlag == 'F') {
                  if (j == stateData.length - 1) record.versionCheckFlag = 'S';
                }
                let id = procList.findIndex(e => e.procCommId === record.procCommId);
                if (id < 0 || stateData[j].transactionCode === 'SEND_O_DONE' || stateData[j].transactionCode === 'TRANS_O_DONE' || stateData[j].transactionCode === 'TRANS_O_FAIL') {
                  record.transactionCode = stateData[j].transactionCode;
                  record.timestamp = stateData[j].timestamp;
                  record.errorMessage = stateData[j].errorMessage;
                  record.fileLink = stateData[j].fileLink;
                  record.userData = stateData[j].userData;
                  record.reProcess = '';
                  record.recordId = stateData[j].recordId;
                  record.processSetupName = `${data.length - k}. Workflow Name : ${record.procName} [${data[k].processSetupId}]`;
                  // 2022.7.11 203728 Add new 
                  record.taskId = stateData[j].taskId;
                  record.reprocessTarget = stateData[j].reprocessTarget;
                  record.senderId = stateData[j].senderId;
                  record.recipientId = stateData[j].recipientId;
                  record.messageName = stateData[j].messageName;
                  record.resourceId = stateData[j].resourceId;
                  if (record.procType == 'MAP') {
                    record.mappingName = ' (After Translation)';
                  }
                  procList.push(record);
                }
              } else if (index === -1 && stateData[j].resourceId.includes('_mq_')) {
                if (stateData[j].transactionCode == 'TRANS_I_DONE') {
                  procList.push({
                    procCommId: stateData[j].taskId.split(':').pop(),
                    mappingName: ' (Before Translation)',
                    procType: 'MAP',
                    transactionCode: stateData[j].transactionCode,
                    timestamp: stateData[j].timestamp,
                    errorMessage: stateData[j].errorMessage,
                    fileLink: stateData[j].fileLink,
                    userData: stateData[j].userData,
                    reProcess: '',
                    recordId: stateData[j].recordId,
                    processSetupName: `${data.length - k}. Workflow Name : ${procData[0].procName} [${data[k].processSetupId}]`,
                    // 2022.7.11 203728 Add new 
                    taskId: stateData[j].taskId,
                    reprocessTarget: stateData[j].reprocessTarget,
                    senderId: stateData[j].senderId,
                    recipientId: stateData[j].recipientId,
                    messageName: stateData[j].messageName,
                    resourceId: stateData[j].resourceId,
                    versionCheckFlag: versionCheckFlag
                  })
                }
              }
            }

            // 203728 sort desc
            procList.sort(function (a, b) {
              if (a.timestamp === b.timestamp) {
                // recordId is only important when timestamp are the same
                return b.recordId - a.recordId;
              }
              return b.timestamp > a.timestamp ? 1 : -1;
            })
            procDataList = procDataList.concat(procList);
          }
        });

        // 2022.7.11 203728 SLI-141

        let len = procDataList.length;
        for (let i = 0; i < len; i++) {
          // set data to re-process
          const record = procDataList[i];
          record.data = [
            {
              "header": {
                "groupId": record.procOwnrId,
                "userId": record.procCompId,
                "processSetupId": record.procSetupIdVer,
                "processId": params.processId,
                "targetFileName": record.userData.fileName,
                "eventCode": "DATA_RE_PROCESS"
              },
              "payload": {
                "messageSequence": params.record.messageSequence,
                "resourceId": record.resourceId,
                "reprocessTarget": record.reprocessTarget,
                "taskId": record.taskId,
                "fileLink": record.fileLink,
                "userData": record.userData,
                "mappingId": record.procType == 'MAP' ? record.procCommId : "",
                "senderId": record.senderId,
                "recipientId": record.recipientId,
                "messageName": record.messageName,
                "fileContent": ""
              }
            }
          ];

          if (record.procType == 'COM') record.data[0].payload.called = "communication";
          if (record.procType == 'DIR') record.data[0].payload.called = "folder";
          if (record.procType == 'MAP') record.data[0].payload.called = "mapper";

          // procDataList[j].transactionCode = 'TRANS_O_FAIL';
          if (record.mappingName == ' (Before Translation)') {
            let index = procDataList.findIndex(e => e.procCommId == record.procCommId && e.mappingName == ' (After Translation)');
            if (index > -1) {
              if (procDataList[index].transactionCode != 'TRANS_O_FAIL') {
                record.mappingName = `<p>$ ${procDataList[index].mappingName}</p><p>$ ${record.mappingName}</p>`;
                record.timestamp = `${procDataList[index].timestamp}|${record.timestamp}`;
                record.recordId = `${procDataList[index].recordId}|${record.recordId}`;
                record.fileLink = `${procDataList[index].fileLink}|${record.fileLink}`;
                record.userData = `${JSON.stringify(procDataList[index].userData)}|${JSON.stringify(record.userData)}`;

                record.data[0].header.groupId = procDataList[index].data[0].header.groupId;
                record.data[0].header.userId = procDataList[index].data[0].header.userId;
                record.data[0].header.processSetupId = procDataList[index].data[0].header.processSetupId;
                record.data[0].header.processId = procDataList[index].data[0].header.processId;
                record.data = `${JSON.stringify(procDataList[index].data)}|${JSON.stringify(record.data)}`;
              } else {
                record.transactionCode = 'TRANS_O_FAIL';
                record.errorMessage = procDataList[index].errorMessage;
                record.mappingName = `<p>$ ${record.mappingName}</p>`;
              }
            } else {
              record.mappingName = `<p>Unknown mapping - ${record.mappingName}</p>`;
              record.transactionCode = 'TRANS_O_FAIL';
            }
          }
        }

        procDataList = procDataList.filter(e => e.mappingName != ' (After Translation)');

        len = procDataList.length;
        for (let i = 0; i < len; i++) {
          const record = procDataList[i];
          record.INDEX = len - i;
          if (len - i == 1 && record.procType != 'MAP') {
            record.data[0].header.targetFileName = "";
            record.data[0].payload.resourceId = "";
            record.data[0].payload.taskId = "";
          }
        }

        commit('SET_STORE_STATE_LIST_INFO', procDataList);
      } catch (err) {
        console.log(err);
        throw err;
      }
    },
    // 2021.10.5 SPKA-231 add function get Object for transaction, transmission
    getData4ReTranslationOrReTransmission: async ({ commit, state }, params) => {
      try {
        // 2021.11.8 203728 SPKA-245 rename
        // 2021.12.09 213960 SPKA-324 Remove "Test" and "Live" radio button  
        // let strEnvMode = state.strEnvMode;
        let returnData = [];

        let url = `${baseURI}/monitoring/users/${params.groupId}/${params.userId}/status/${params.processId}/${params.record.messageSequence}`;
        await axios.get(url).then((response_state) => {
          let data = response_state.data.data;

          if (params.reAction === "ReTranslation") {
            for (let k = data.length - 1; k >= 0; k -= 1) {
              let stateData = data[k].state;
              if (returnData.length > 0) break;
              for (let j = stateData.length - 1; j >= 0; j -= 1) {
                if (stateData[j].transactionCode === 'SEND_I_DONE' || stateData[j].transactionCode === 'RECV_I_DONE') {
                  let record = data[k];
                  record.state = [];
                  record.state.push(stateData[j]);
                  record = {
                    "header": {
                      "groupId": record.groupId,
                      "userId": record.userId,
                      "processSetupId": record.processSetupId,
                      "processId": record.processId,
                      "targetFileName": record.targetFileName,
                      "eventCode": "DATA_RE_PROCESS"
                    },
                    "payload": {
                      "messageSequence": params.record.messageSequence,
                      "resourceId": record.state[0].resourceId,
                      "reprocessTarget": record.state[0].reprocessTarget,
                      "taskId": record.state[0].taskId,
                      "fileLink": record.state[0].fileLink,
                      "called": "communication",
                      "userData": record.state[0].userData,
                      "mappingId": record.state[0].mappingId,
                      "senderId": record.state[0].senderId,
                      "recipientId": record.state[0].recipientId,
                      "messageName": record.state[0].messageName,
                      "fileContent": ""
                    }
                  }
                  returnData.push(record);
                  break;
                }
              }
            }
          } else if (params.reAction === "ReTransmission") {
            for (let k = 0; data.length > k; k += 1) {
              let stateData = data[k].state;
              if (returnData.length > 0) break;
              for (let j = 0; stateData.length > j; j += 1) {
                if (stateData[j].transactionCode === 'SEND_O_DONE') {
                  let record = data[k];
                  record.state = [];
                  record.state.push(stateData[j]);
                  record = {
                    "header": {
                      "groupId": record.groupId,
                      "userId": record.userId,
                      "processSetupId": record.processSetupId,
                      "processId": record.processId,
                      "targetFileName": record.targetFileName,
                      "eventCode": "DATA_RE_PROCESS"
                    },
                    "payload": {
                      "messageSequence": params.record.messageSequence,
                      "resourceId": record.state[0].resourceId,
                      "reprocessTarget": record.state[0].reprocessTarget,
                      "taskId": record.state[0].taskId,
                      "fileLink": record.state[0].fileLink,
                      "called": "communication",
                      "userData": record.state[0].userData,
                      "mappingId": record.state[0].mappingId,
                      "senderId": record.state[0].senderId,
                      "recipientId": record.state[0].recipientId,
                      "messageName": record.state[0].messageName,
                      "fileContent": ""
                    }
                  }
                  returnData.push(record);
                  break;
                }
              }
            }
          }
        });
        return returnData;
      } catch (err) {
        console.log(err);
      }
    },
    getinputFileContens: async ({ commit }, inputFileLink) => {
      await axios.get(inputFileLink, { withCredentials: true }).then((response) => {
        commit('SET_STORE_INPUT_FILE_CONTENTS', response.data['fileContent']);
      }).catch((ex) => {
        console.log(ex);
      });
    },
    getoutputFileContens: async ({ commit }, outputFileLink) => {
      await axios.get(outputFileLink, { withCredentials: true }).then((response) => {
        commit('SET_STORE_OUTPUT_FILE_CONTENTS', response.data['fileContent']);
      }).catch((ex) => {
        console.log(ex);
      });
    },
    getoutputBizFileContens: async ({ commit }, outputBizFileLink) => {
      console.log(`outputBizFileLink : ${outputBizFileLink}`);
      await axios.get(outputBizFileLink, { withCredentials: true }).then((response) => {
        commit('SET_STORE_OUTPUT_BIZFILE_CONTENTS', response.data['fileContent']);
      }).catch((ex) => {
        console.log(ex);
      });
    },
    getProcessSetupList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/process/list/fortransaction`, params);
        commit('SET_STORE_PROCESS_SETUP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PROCESS_SETUP_LIST', null);
        throw err;
      }
    },
    execReTranslation: async ({ commit, state }, params) => {
      try {
        const response = await axios.post(`${reprocessURI}/retrans`, params, { withCredentials: true });
        commit('SET_STORE_MONITOR_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_MONITOR_LIST', []);
        throw err;
      }
    },
    execReTransmission: async ({ commit, state }, params) => {
      try {
        const response = await axios.post(`${reprocessURI}/resend`, params, { withCredentials: true });
        commit('SET_STORE_MONITOR_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_MONITOR_LIST', []);
        throw err;
      }
    },
  },
  getters: {
    monitoringList: state => state.monitoringList,
    communicationInfo: state => state.communicationInfo,
    inputFileContents: state => state.inputFileContents,
    outputFileContents: state => state.outputFileContents,
    outputBizFileContents: state => state.outputBizFileContents,
    processSetupList: state => state.processSetupList,
    totalCnt: state => state.totalCnt,
    statusInfo: state => state.statusInfo,
    stateViewPopupListInfo: state => state.stateViewPopupListInfo
  },
};

export default monitoringStoreModule;
